import React from "react";
import { ArrowPathIcon } from "@heroicons/react/24/outline";

import MainPageWrapper from "@/components/MainPageWrapper/MainPageWrapper";
import { Card } from "@/components/Card/Card";
import { LastSyncStatus } from "@/modules/stochastic/features/shared/components/LastSyncStatus/LastSyncStatus";
import { useMPDashboard } from "../../hooks/useMPDashboard";
import MPDashboardSummary from "../MPDashboardSummary/MPDashboardSummary";
import MPDashboardFilters from "../MPDashboardFilters/MPDashboardFilters";
import MPDashboardTable from "../MPDashboardTable/MPDashboardTable";

const MPDashboardPage: React.FC = () => {
  const {
    loading,
    refreshing,
    items,
    totalFilteredCount,
    summary,
    expanded,
    setExpanded,
    canExpand,
    sortField,
    sortDirection,
    handleSort,
    statusFilter,
    setStatusFilter,
    chipFilters,
    statusCounts,
    totalZipCount,
    lastSync,
    handleRefresh,
    csvLoading,
    handleExportCsv,
  } = useMPDashboard();

  return (
    <MainPageWrapper
      actions={
        <div className="flex items-center gap-3">
          <LastSyncStatus lastSync={lastSync} />
          <button
            className="inline-flex items-center gap-2 rounded-md border border-gray-300 bg-white px-3 py-1.5 text-sm font-medium text-gray-700 transition-colors hover:bg-gray-50 disabled:cursor-not-allowed disabled:opacity-50 dark:border-gray-600 dark:bg-gray-800 dark:text-gray-300 dark:hover:bg-gray-700"
            disabled={refreshing}
            onClick={handleRefresh}
          >
            <ArrowPathIcon
              className={`h-4 w-4 ${refreshing ? "animate-spin" : ""}`}
            />
            Refresh
          </button>
        </div>
      }
      subtitle="ZIP-level sales data with relative market presence"
      title="Market Presence"
    >
      <Card className="bg-white p-6 dark:bg-slate-800">
        <div className="space-y-4">
          <p className="text-xs text-gray-500 dark:text-gray-400">
            Customers &divide; Households &middot; Minimum 1% presence +
            qualifying sales for direct mail recommendation
          </p>

          <MPDashboardSummary
            loading={loading}
            summary={summary}
            totalZipCount={totalZipCount}
          />

          <MPDashboardFilters
            chipFilters={chipFilters}
            csvLoading={csvLoading}
            onExportCsv={handleExportCsv}
            onFilterChange={setStatusFilter}
            statusCounts={statusCounts}
            statusFilter={statusFilter}
          />

          <MPDashboardTable
            canExpand={canExpand}
            expanded={expanded}
            items={items}
            loading={loading}
            onSort={handleSort}
            onToggleExpand={setExpanded}
            sortDirection={sortDirection}
            sortField={sortField}
            totalFilteredCount={totalFilteredCount}
          />
        </div>
      </Card>
    </MainPageWrapper>
  );
};

export default MPDashboardPage;
